import { render, staticRenderFns } from "./VehicleServices.vue?vue&type=template&id=8decdc2a&"
import script from "./VehicleServices.vue?vue&type=script&lang=js&"
export * from "./VehicleServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports